import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

/**
 * Feel free to modify this type for this project (only) here
 * For example, if you add a whole new block of text that the jslib does not have a spot for already
 *
 * This is not necessary if you are just overriding text for a pre-existing message id
 */
type ThisProjectMessages = {
    step: {
        pending: {
            redirectUrl: string;
        };
    };
};

/**
 * Define the actual language strings here, as needed.
 * This object should be sparse, so you inherit language from the library. Only override what you need to.
 *
 * The complicated type ensures your object adheres to the library's type(s), as well as any additional type you've
 * created in ThisProjectMessages.
 */
export const medicalMessagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    postalCode: 'Postal code',
    postalCodePlaceholder: 'Postal code',
    emailAddress: 'Email address (Personal email address is recommended)',
    tryAgain: 'Try again',
    step: {
        docUpload: {
            subtitle: 'Documents will be reviewed in a few minutes by staff at SheerID, a trusted partner.',
        },
        pending: {
            titleReview: 'Processing',
            subtitle: 'SheerID is reviewing your documents, to confirm your status.<br><br>This process may take up to 20 minutes.',
            subtitle2: 'Wait here or let us notify you of the outcome.',
            redirectUrl: 'https://www.levi.com/US/en_US/',
        },
        success: {
            copyCouponCode: 'Copy Promo Code',
            redirectButtonText: 'Continue',
        },
    },
};
